import { useLoaderData } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { Tickets } from "./Tickets";
import { ITicketsData } from "./TicketsData";

export const ticketsRouteLoader = async ({ request }: { request: any, params: any }) => {
  return doFetch(`my-profile-tickets`, { signal: request.signal }, true, true);
}

export const TicketsRoute = () => {
  const data = useLoaderData() as ITicketsData;
  return (
    <Tickets data={data} />
  )
}